import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useCallback } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { useAccordionPanelContext } from '../AccordionPanel.Context/index.es.js';

const AccordionPanelHeader = ({ children, ...props })=>{
    const [{ open, size, onCard, inlineInfo, ariaId }, { handleHeaderClick }] = useAccordionPanelContext();
    const handleClick = useCallback((event)=>{
        handleHeaderClick();
        props.onClick?.(event);
    }, [
        handleHeaderClick,
        props
    ]);
    return jsxs("button", {
        ...props,
        "aria-controls": ariaId,
        "aria-expanded": open,
        className: classNames('accordion-panel-header', size, {
            card: onCard
        }),
        "data-testid": "accordion-panel-header",
        onClick: handleClick,
        type: "button",
        children: [
            children,
            /*#__PURE__*/ React__default.isValidElement(inlineInfo) && jsx("div", {
                className: classNames('accordion-panel-header-inline-info'),
                children: inlineInfo
            }),
            jsx("div", {
                className: classNames('accordion-panel-header-icon'),
                children: jsx(Icon, {
                    className: "text-icon-neutral",
                    name: open ? 'ChevronUpSolid' : 'ChevronDownSolid',
                    size: 24
                })
            })
        ]
    });
};
AccordionPanelHeader.displayName = 'AccordionPanelHeader';

export { AccordionPanelHeader };
//# sourceMappingURL=AccordionPanelHeader.es.js.map
